exports = module.exports = require("../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vote{width:339px;background:#f7f7f7;border-radius:6px;padding:15px 18px;margin:auto;box-sizing:border-box}.vote .title-wrapper{line-height:23px}.vote .title-wrapper .title{font-weight:700;font-size:16px;color:#303133;letter-spacing:0;vertical-align:top}.vote .title-wrapper .type-title{font-size:12px;color:#fca100;letter-spacing:0;vertical-align:middle}.vote .detail{margin-top:12px;font-size:12px;color:#999;letter-spacing:0;line-height:17px}.vote .button{margin:10px auto 3px;width:166px;height:38px;background-image:-webkit-linear-gradient(53deg,#ffb422,#ffe363);background-image:linear-gradient(37deg,#ffb422,#ffe363);border-radius:6px;font-size:14px;font-weight:700;color:#303133;letter-spacing:0;text-align:center;line-height:38px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/component/vote/scss/index.scss
// module id = 655
// module chunks = 0 1 2 3